import ApiService from './api.service.js';

class JournalEntryService {
    constructor() {
        this.baseUrl = '/journal-entry';
    }

    // Create a new journal entry
    async createJournalEntry(companyId, journalEntryData, entryType = 'JE') {
        const response = await ApiService.post(`${this.baseUrl}/company/${companyId}?type=${entryType}`, journalEntryData);
        return response.data;
    }

    // Get all journal entries for a company
    async getJournalEntries(companyId, params = {}) {
        const queryParams = new URLSearchParams(params).toString();
        const response = await ApiService.get(`${this.baseUrl}/company/${companyId}?${queryParams}`);
        return response.data;
    }

    // Entry number autocomplete suggestions
    async getEntryNoSuggestions(companyId, params = {}) {
        const queryParams = new URLSearchParams(params).toString();
        const url = queryParams
            ? `${this.baseUrl}/company/${companyId}/entry-no-suggestions?${queryParams}`
            : `${this.baseUrl}/company/${companyId}/entry-no-suggestions`;
        const response = await ApiService.get(url);
        return response.data;
    }

    // Get a single journal entry by id
    async getJournalEntryById(id) {
        const response = await ApiService.get(`${this.baseUrl}/${id}`);
        return response.data;
    }

    /** Journal entries where customerInvoiceId matches (optional companyId query for scoping) */
    async getJournalEntriesByCustomerInvoiceId(customerInvoiceId, companyId) {
        const params = companyId != null && companyId !== ''
            ? new URLSearchParams({ companyId: String(companyId) }).toString()
            : '';
        const qs = params ? `?${params}` : '';
        const response = await ApiService.get(
            `${this.baseUrl}/customer-invoice/${customerInvoiceId}${qs}`
        );
        return response.data;
    }

    /** Journal entries where receivePaymentId matches */
    async getJournalEntriesByReceivePaymentId(receivePaymentId, companyId) {
        const params = companyId != null && companyId !== ''
            ? new URLSearchParams({ companyId: String(companyId) }).toString()
            : '';
        const qs = params ? `?${params}` : '';
        const response = await ApiService.get(
            `${this.baseUrl}/receive-payment/${receivePaymentId}${qs}`
        );
        return response.data;
    }

    /** Journal entries where billId matches (optional companyId query) */
    async getJournalEntriesByBillId(billId, companyId) {
        const params = companyId != null && companyId !== ''
            ? new URLSearchParams({ companyId: String(companyId) }).toString()
            : '';
        const qs = params ? `?${params}` : '';
        const response = await ApiService.get(`${this.baseUrl}/bill/${billId}${qs}`);
        return response.data;
    }

    /** Journal entries where vendorPayBillId matches */
    async getJournalEntriesByVendorPayBillId(payBillId, companyId) {
        const params = companyId != null && companyId !== ''
            ? new URLSearchParams({ companyId: String(companyId) }).toString()
            : '';
        const qs = params ? `?${params}` : '';
        const response = await ApiService.get(
            `${this.baseUrl}/vendor-pay-bill/${payBillId}${qs}`
        );
        return response.data;
    }

    // Update a journal entry
    async updateJournalEntry(id, journalEntryData) {
        const response = await ApiService.put(`${this.baseUrl}/${id}`, journalEntryData);
        return response.data;
    }

    // Post a journal entry
    async postJournalEntry(id) {
        const response = await ApiService.post(`${this.baseUrl}/${id}/post`);
        return response.data;
    }

    // Cancel a journal entry
    async cancelJournalEntry(id) {
        const response = await ApiService.post(`${this.baseUrl}/${id}/cancel`);
        return response.data;
    }

    // Delete a journal entry
    async deleteJournalEntry(id) {
        const response = await ApiService.delete(`${this.baseUrl}/${id}`);
        return response.data;
    }

    // Generate next entry number for a company
    async generateNextEntryNumber(companyId, entryType = 'JE') {
        const response = await ApiService.get(`${this.baseUrl}/company/${companyId}/next-entry-number?type=${entryType}`);
        return response.data;
    }

    async getLinkOptions(companyId, relatedType) {
        const response = await ApiService.get(
            `${this.baseUrl}/company/${companyId}/link-options?type=${encodeURIComponent(relatedType)}`
        );
        return response.data;
    }

    async linkJournalEntryRelated(journalEntryId, relatedType, relatedId) {
        const response = await ApiService.post(`${this.baseUrl}/${journalEntryId}/link-related`, {
            relatedType,
            relatedId,
        });
        return response.data;
    }
}

export default new JournalEntryService(); 